import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux'
import { AppDispatch, RootState } from './store.ts'

// Use throughout your app instead of plain `useDispatch` and `useSelector`
export const useAppDispatch: any = () => useDispatch<AppDispatch>()
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector
